<div class="modern-admin-page">
  <!-- Page Header -->
  <div class="page-header-card">
    <div class="header-content">
      <div class="page-title-section">
        <h1 class="page-title bangla-heading">কর সংগ্রহ তালিকা</h1>
        <p class="page-subtitle">সমস্ত কর সংগ্রহের তথ্য দেখুন এবং পরিচালনা করুন</p>
      </div>
      <div class="page-actions">
        <button (click)="openBulkSmsModal()" class="btn-secondary-modern" [disabled]="data.length === 0">
          <i class="fas fa-sms"></i>
          বাল্ক এসএমএস
        </button>
        <button (click)="exportTableToExcel()" class="btn-primary-modern" [disabled]="data.length === 0">
          <i class="fas fa-file-excel"></i>
          এক্সেল এক্সপোর্ট
        </button>
      </div>
    </div>
  </div>

  <!-- Filters and Actions Section -->
  <div class="content-card slide-up">
    <div class="card-header">
      <h3 class="card-title bangla-title">
        <i class="fas fa-filter"></i>
        ফিল্টার এবং অ্যাকশন
      </h3>
    </div>
    
    <div class="card-body">
      <!-- Filter Controls -->
      <div class="filters-section">
        <div class="filter-row">
          <div class="filter-group">
            <label class="filter-label bangla-label">পৃষ্ঠা সাইজ:</label>
            <select (change)="changePageSize($event)" class="form-control-modern">
              <option *ngFor="let size of pageSizes" [value]="size" [selected]="size === itemsPerPage">
                {{ size }}
              </option>
            </select>
          </div>
          
          <div class="filter-group">
            <label class="filter-label bangla-label">ওয়ার্ড ফিল্টার:</label>
            <select (change)="filterByWard($event)" class="form-control-modern" id="wardDropdown">
              <option value="">সব ওয়ার্ড</option>
              <option *ngFor="let ward of wards" [value]="ward.ward_number">
                {{ ward.ward_number }} - {{ ward.ward_name }}
              </option>
            </select>
          </div>

          <div class="filter-group">
            <label class="filter-label bangla-label">তারিখ (শুরু):</label>
            <input 
              type="date" 
              class="form-control-modern" 
              (change)="filterByDateRange()"
              #startDateFilter
              id="startDateFilter"
            >
          </div>

          <div class="filter-group">
            <label class="filter-label bangla-label">তারিখ (শেষ):</label>
            <input 
              type="date" 
              class="form-control-modern" 
              (change)="filterByDateRange()"
              #endDateFilter
              id="endDateFilter"
            >
          </div>

          <div class="filter-group">
            <label class="filter-label bangla-label">অনুসন্ধান:</label>
            <input 
              type="text" 
              placeholder="সব ক্ষেত্রে অনুসন্ধান করুন..." 
              class="form-control-modern" 
              (input)="performFullTextSearch($event)"
              id="fullTextSearch"
            >
          </div>

          <div class="filter-group">
            <button class="btn-outline-modern" (click)="clearFilters()">
              <i class="fas fa-times"></i>
              ফিল্টার সাফ করুন
            </button>
          </div>
        </div>
      </div>

      <!-- Current Tab Status -->
      <div class="tab-status-info">
        <div class="status-badge">
          <i class="fas fa-info-circle"></i>
          <strong>{{ getTabTitle() }}</strong> - {{ totalItems }} টি রেকর্ড
          <span *ngIf="fullTextSearchTerm" class="search-indicator">
            | অনুসন্ধান: "{{ fullTextSearchTerm }}"
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Data Table Section with Integrated Tabs -->
  <div class="content-card slide-up">
    <div class="card-header">
      <div class="card-header-content">
        <div class="card-title-section">
          <h3 class="card-title bangla-title">
            <i class="fas fa-table"></i>
            কর সংগ্রহ ডেটা
          </h3>
          <div class="card-actions">
            <span class="data-count">
              মোট <strong>{{totalItems}}</strong> টি রেকর্ড
            </span>
          </div>
        </div>
        
        <!-- Tab Navigation Inside Card Header -->
        <div class="tab-navigation-inline">
          <div class="nav-tabs-inline" role="tablist">
            <button 
              class="nav-tab-inline" 
              [class.active]="activeTab === 'all'" 
              (click)="switchTab('all')" 
              type="button">
              <i class="fas fa-list-alt"></i>
              <span>সকল কর সংগ্রহ</span>
              <span class="tab-badge" *ngIf="activeTab === 'all'">{{ totalItems }}</span>
            </button>
            
            <button 
              class="nav-tab-inline" 
              [class.active]="activeTab === 'unpaid'" 
              (click)="switchTab('unpaid')" 
              type="button">
              <i class="fas fa-exclamation-triangle"></i>
              <span>অপরিশোধিত কর</span>
              <span class="tab-badge danger" *ngIf="activeTab === 'unpaid'">{{ totalItems }}</span>
            </button>
            
            <button 
              class="nav-tab-inline" 
              [class.active]="activeTab === 'paid'" 
              (click)="switchTab('paid')" 
              type="button">
              <i class="fas fa-check-circle"></i>
              <span>পরিশোধিত কর</span>
              <span class="tab-badge success" *ngIf="activeTab === 'paid'">{{ totalItems }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    
    <div class="card-body">
      <!-- Column Filters -->
      <div class="column-filters">
        <div class="filter-inputs">
          <input
            type="text"
            #nameFilter
            (input)="filterData($event, 'name')"
            placeholder="নাম"
            class="filter-input"
          />
          <input
            type="text"
            #mobileNumberFilter
            (input)="filterData($event, 'mobile_number')"
            placeholder="মোবাইল"
            class="filter-input"
          />
          <input
            type="text"
            #holdingNumberFilter
            (input)="filterData($event, 'holding_number')"
            placeholder="হোল্ডিং নং"
            class="filter-input"
          />
          <input
            type="text"
            #wardNumberFilter
            (input)="filterData($event, 'ward_number')"
            placeholder="ওয়ার্ড নং"
            class="filter-input"
          />
          <input
            type="text"
            #gramOrRastaFilter
            (input)="filterData($event, 'gram_or_rasta')"
            placeholder="গ্রাম/রাস্তা"
            class="filter-input"
          />
        </div>
      </div>

      <!-- Loading State -->
      <div *ngIf="isLoading" class="loading-state">
        <div class="loading-spinner">
          <i class="fas fa-spinner fa-spin"></i>
          <p class="bangla-text">ডেটা লোড হচ্ছে...</p>
        </div>
      </div>

      <!-- Empty State -->
      <div *ngIf="!isLoading && (!paginatedData || paginatedData.length === 0)" class="empty-state">
        <div class="empty-icon">
          <i class="fas fa-receipt"></i>
        </div>
        <h3 class="bangla-title">কোন কর সংগ্রহ রেকর্ড পাওয়া যায়নি</h3>
        <p class="bangla-text">এই ক্যাটেগরিতে কোন ডেটা পাওয়া যায়নি অথবা আপনার ফিল্টার অনুযায়ী কোন রেকর্ড নেই।</p>
        <button type="button" (click)="clearFilters()" class="btn-primary-modern">
          <i class="fas fa-refresh"></i>
          ফিল্টার রিসেট করুন
        </button>
      </div>

      <!-- Data Table -->
      <div *ngIf="!isLoading && paginatedData && paginatedData.length > 0" class="table-responsive">
        <table id="taxCollectionTable" class="table-modern" role="table" aria-label="কর সংগ্রহ তালিকা">
          <thead>
            <tr role="row">
              <th class="actions-column" role="columnheader">অ্যাকশন</th>
              <th class="sortable-header" (click)="sortData('name')" 
                  role="columnheader" 
                  [attr.aria-sort]="currentSortColumn === 'name' ? (currentSortDirection === 'asc' ? 'ascending' : 'descending') : 'none'"
                  tabindex="0"
                  (keydown.enter)="sortData('name')"
                  (keydown.space)="sortData('name')"
                  [attr.aria-label]="'নাম কলাম, ' + (currentSortColumn === 'name' ? (currentSortDirection === 'asc' ? 'ক্রমবর্ধমান' : 'ক্রমহ্রাসমান') + ' সাজানো' : 'সাজানো যাবে')">
                <span class="bangla-label">নাম</span>
                <i *ngIf="currentSortColumn === 'name'" 
                   class="fas sort-icon"
                   [class.fa-sort-up]="currentSortDirection === 'asc'"
                   [class.fa-sort-down]="currentSortDirection === 'desc'">
                </i>
              </th>
              <th class="sortable-header" (click)="sortData('mobile_number')">
                <span class="bangla-label">মোবাইল নম্বর</span>
                <i *ngIf="currentSortColumn === 'mobile_number'" 
                   class="fas sort-icon"
                   [class.fa-sort-up]="currentSortDirection === 'asc'"
                   [class.fa-sort-down]="currentSortDirection === 'desc'">
                </i>
              </th>
              <th class="sortable-header" (click)="sortData('holding_number')">
                <span class="bangla-label">হোল্ডিং নং</span>
                <i *ngIf="currentSortColumn === 'holding_number'" 
                   class="fas sort-icon"
                   [class.fa-sort-up]="currentSortDirection === 'asc'"
                   [class.fa-sort-down]="currentSortDirection === 'desc'">
                </i>
              </th>
              <th class="sortable-header" (click)="sortData('ward_number')">
                <span class="bangla-label">ওয়ার্ড নং</span>
                <i *ngIf="currentSortColumn === 'ward_number'" 
                   class="fas sort-icon"
                   [class.fa-sort-up]="currentSortDirection === 'asc'"
                   [class.fa-sort-down]="currentSortDirection === 'desc'">
                </i>
              </th>
              <th class="sortable-header" (click)="sortData('gram_or_rasta')">
                <span class="bangla-label">গ্রাম/রাস্তা</span>
                <i *ngIf="currentSortColumn === 'gram_or_rasta'" 
                   class="fas sort-icon"
                   [class.fa-sort-up]="currentSortDirection === 'asc'"
                   [class.fa-sort-down]="currentSortDirection === 'desc'">
                </i>
              </th>
              <th class="sortable-header" (click)="sortData('financial_year')">
                <span class="bangla-label">অর্থবছর</span>
                <i *ngIf="currentSortColumn === 'financial_year'" 
                   class="fas sort-icon"
                   [class.fa-sort-up]="currentSortDirection === 'asc'"
                   [class.fa-sort-down]="currentSortDirection === 'desc'">
                </i>
              </th>
              <th class="sortable-header" (click)="sortData('tax_amount')">
                <span class="bangla-label">পরিমাণ</span>
                <i *ngIf="currentSortColumn === 'tax_amount'" 
                   class="fas sort-icon"
                   [class.fa-sort-up]="currentSortDirection === 'asc'"
                   [class.fa-sort-down]="currentSortDirection === 'desc'">
                </i>
              </th>
              <th *ngIf="activeTab === 'all'" class="sortable-header" (click)="sortData('collection_date')">
                <span class="bangla-label">সংগ্রহের তারিখ</span>
                <i *ngIf="currentSortColumn === 'collection_date'" 
                   class="fas sort-icon"
                   [class.fa-sort-up]="currentSortDirection === 'asc'"
                   [class.fa-sort-down]="currentSortDirection === 'desc'">
                </i>
              </th>
              <th>
                <span class="bangla-label">অবস্থা</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let record of paginatedData; let i = index; trackBy: trackByRecordId" [class.table-striped]="i % 2 === 0">
              <td class="actions-cell">
                <div class="action-buttons-cell">
                  <button
                    *ngIf="activeTab === 'all'"
                    title="রসিদ দেখুন"
                    class="btn-action-sm"
                    (click)="viewReceipt(record)"
                    [attr.aria-label]="'রসিদ দেখুন ' + record.name + ' এর জন্য'"
                  >
                    <i class="fas fa-receipt" aria-hidden="true"></i>
                  </button>
                  <button
                    title="কর আদায় করুন"
                    class="btn-action-sm"
                    (click)="navigateToTaxCollection(record.assessment_qr_code)"
                    [attr.aria-label]="'কর আদায় করুন ' + record.name + ' এর জন্য'"
                  >
                    <i class="fas fa-money-bill-wave" aria-hidden="true"></i>
                  </button>
                </div>
              </td>
              <td class="bangla-text">{{ record.name }}</td>
              <td class="bangla-text">{{ record.mobile_number || 'N/A' }}</td>
              <td class="bangla-text">{{ record.holding_number }}</td>
              <td class="bangla-text">
                {{
                  unionDomain.convertEnglishHoldingNumberToBanglaHoldingNumber(
                    record.ward_number.toString()
                  )
                }}
              </td>
              <td class="bangla-text">{{ record.gram_or_rasta }}</td>
              <td class="bangla-text">{{ formatFinancialYear(record.financial_year) }}</td>
              <td class="bangla-text tax-amount">
                <span *ngIf="activeTab === 'all'">
                  {{ record.debit_credit === 'D' ? '+' : '-' }}{{ record.tax_amount }}
                </span>
                <span *ngIf="activeTab !== 'all'">
                  {{ record.tax_amount }}
                </span>
              </td>
              <td *ngIf="activeTab === 'all'" class="bangla-text">
                {{ record.collection_date ? (record.collection_date | date:'dd/MM/yyyy') : 'N/A' }}
              </td>
              <td>
                <span [class]="getStatusBadgeClass(record)" class="status-badge-modern">
                  {{ getStatusText(record) }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Total Summary -->
      <div *ngIf="!isLoading && paginatedData && paginatedData.length > 0" class="total-summary">
        <div class="total-cards">
          <div class="total-card">
            <div class="total-icon">
              <i class="fas fa-calculator"></i>
            </div>
            <div class="total-content">
              <h4 class="total-label bangla-text">পৃষ্ঠার মোট</h4>
              <p class="total-amount" [class.negative]="displayedTotal < 0">
                {{ displayedTotal >= 0 ? '+' : '' }}{{ formatNumber(displayedTotal) }} ৳
              </p>
            </div>
          </div>
          
          <div class="total-card primary">
            <div class="total-icon">
              <i class="fas fa-chart-line"></i>
            </div>
            <div class="total-content">
              <h4 class="total-label bangla-text">সর্বমোট</h4>
              <p class="total-amount" [class.negative]="currentTotal < 0">
                {{ currentTotal >= 0 ? '+' : '' }}{{ formatNumber(currentTotal) }} ৳
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Pagination Info -->
      <div class="pagination-info">
        <span class="info-badge">
          {{ itemsPerPage === 'All' ? 'সব ' + totalItems + ' টি আইটেম দেখানো হচ্ছে' : 
            'দেখানো হচ্ছে ' + ((currentPage - 1) * (+itemsPerPage) + 1) + ' - ' +
            (currentPage * (+itemsPerPage) > totalItems ? totalItems : currentPage * (+itemsPerPage)) +
            ' এর মধ্যে ' + totalItems + ' টি' }}
        </span>
      </div>

      <!-- Pagination Controls -->
      <nav *ngIf="itemsPerPage !== 'All' && totalPages > 1" class="pagination-nav">
        <div class="pagination-modern">
          <button class="pagination-btn" [disabled]="currentPage === 1" (click)="changePage(1)">
            <i class="fas fa-angle-double-left"></i>
            প্রথম
          </button>
          <button class="pagination-btn" [disabled]="currentPage === 1" (click)="changePage(currentPage - 1)">
            <i class="fas fa-angle-left"></i>
            পূর্ববর্তী
          </button>
          
          <div class="page-numbers">
            <button
              class="page-number"
              *ngFor="let page of getPaginationPages()"
              [class.active]="page === currentPage"
              (click)="changePage(page)"
            >
              {{ page }}
            </button>
          </div>
          
          <button class="pagination-btn" [disabled]="currentPage === totalPages" (click)="changePage(currentPage + 1)">
            পরবর্তী
            <i class="fas fa-angle-right"></i>
          </button>
          <button class="pagination-btn" [disabled]="currentPage === totalPages" (click)="changePage(totalPages)">
            শেষ
            <i class="fas fa-angle-double-right"></i>
          </button>
        </div>
      </nav>
    </div>
  </div>
</div>

<!-- Bulk SMS Modal -->
<div class="modal fade" [class.show]="showBulkSmsModal" [style.display]="showBulkSmsModal ? 'block' : 'none'" 
     id="bulkSmsModal" tabindex="-1" aria-labelledby="bulkSmsModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content modal-modern">
      <div class="modal-header">
        <h5 class="modal-title bangla-title" id="bulkSmsModalLabel">
          <i class="fas fa-sms mr-2"></i>বাল্ক এসএমএস - {{ getTabTitle() }}
        </h5>
        <button type="button" class="btn-close" (click)="closeBulkSmsModal()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      
      <div class="modal-body">
        <!-- Recipients Info -->
        <div class="alert alert-info-modern">
          <i class="fas fa-info-circle"></i>
          <div class="alert-content">
            <strong>প্রাপকগণ:</strong> {{ bulkSmsData.recipients.length }} টি মোবাইল নম্বর
            <button class="btn btn-sm btn-link p-0 ml-2" 
                    type="button" (click)="toggleRecipientsList()">
              {{ showRecipientsList ? 'তালিকা লুকান' : 'তালিকা দেখুন' }}
              <i class="fas" [class.fa-chevron-down]="!showRecipientsList" [class.fa-chevron-up]="showRecipientsList"></i>
            </button>
          </div>
        </div>
        
        <div *ngIf="showRecipientsList" class="recipients-list">
          <div class="card card-body">
            <small class="text-muted bangla-text">মোবাইল নম্বরসমূহ:</small>
            <div class="mt-2 recipients-container">
              <span *ngFor="let number of bulkSmsData.recipients; let last = last" class="recipient-badge">
                {{ number }}
              </span>
            </div>
          </div>
        </div>

        <!-- Message Input -->
        <div class="form-group-modern">
          <label for="bulkSmsMessage" class="bangla-label">বার্তা:</label>
          <textarea id="bulkSmsMessage" class="form-control-modern" rows="4" 
                    [(ngModel)]="bulkSmsData.message" 
                    (input)="updateSmsCharacterCount()"
                    placeholder="এখানে আপনার এসএমএস বার্তা লিখুন..."></textarea>
          
          <!-- Character Count -->
          <div class="sms-stats">
            <div class="stats-item">
              <i class="fas fa-font"></i>
              <span>অক্ষর: {{ smsCharCount }}</span>
            </div>
            <div class="stats-item">
              <i class="fas fa-layer-group"></i>
              <span>এসএমএস অংশ: {{ smsPartsCount }}</span>
            </div>
            <div class="stats-item">
              <i class="fas fa-minus-circle"></i>
              <span>বাকি: {{ remainingChars }}</span>
            </div>
          </div>
        </div>
      </div>
      
      <div class="modal-footer">
        <button type="button" class="btn-outline-modern" (click)="closeBulkSmsModal()">
          <i class="fas fa-times"></i>
          বাতিল
        </button>
        <button type="button" class="btn-primary-modern" (click)="sendBulkSms()"
                [disabled]="!bulkSmsData.message.trim() || bulkSmsData.recipients.length === 0">
          <i class="fas fa-paper-plane"></i>
          এসএমএস পাঠান
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Backdrop -->
<div class="modal-backdrop fade" [class.show]="showBulkSmsModal" 
     [style.display]="showBulkSmsModal ? 'block' : 'none'"></div>
